import advice_En from '../common/scripts/advice_of_day_widget/advice_of_day_en'
import initAdviceOfDayBlock from '../common/scripts/advice_of_day_widget/advice_of_day'
import { AdviceItem } from '../common/scripts/carousel/types/items'

export const language = document.documentElement.lang

const CONTENT_ITEMS = {
  en: advice_En
}

const getItems = async (language: string, dynamic: boolean) => {
  if (dynamic) {
    return await window.CarouselLoader.load<AdviceItem>('advice')
  }

  return CONTENT_ITEMS[language]
}

const init = async () => {
  const blocks: HTMLElement[] = Array.from(
    document.querySelectorAll('[data-mp-content-type="advice_of_day_widget"]')
  )

  for (const block of blocks) {
    const isDynamic = block.dataset.mpDynamic === 'true'
    const items = await getItems(language, isDynamic)

    initAdviceOfDayBlock(block, items)
  }
}

// Dynamic content loading requires async.  Need to make sure experiments have finished loading first.
if (window.experimentsLoaded) {
  // noinspection JSIgnoredPromiseFromCall
  init()
} else {
  document.addEventListener('experiment:initialized', () => {
    // noinspection JSIgnoredPromiseFromCall
    init()
  })
}
